
// import ServiceCards from "./ServiceCards";
// import ServiceData from "./ServiceData";

import {Link} from 'react-router-dom'


const GrandInuagration = () => {


  // console.log(ServiceData[0].Desc);
  return (
    <>
      <section className="causes-section1">
        <div className="icon-one1 paroller1" data-paroller-factor="-0.20" data-paroller-factor-lg="-0.20" data-paroller-factor-sm="-0.10" data-paroller-type="foreground" data-paroller-direction="horizontal" style={{ transform: "translateX(29px)", transition: "transform 0s linear 0s", willChange: "transform" }}><span className="flaticon-heart-2"></span></div>

        <div className="auto-container">

          <div className="sec-title centered">

            <h2> Welcome to Yugal Kunj Canada </h2>

          </div>

        </div>


        <div className="auto-container">

          <div className="sec-title centered">
            <div className="upper-icon1"></div>
            <h2>Grand Inauguration of Yugal Kunj    </h2>

          </div>

          <div className="row row-flex clearfix justify-content-center">

            {/* <!--Cause Block--> */}

            <div className="cause-block1 col-lg-4 col-md-6 col-sm-12">
        <div className="inner-box1 wow fadeInUp animated"  >
          <div className="image-box1">
            <figure className="image1">
              <Link to="/USA/InaugurationEvents" >
                <img src="https://yugalkunj.org/images/YUGAL%20KUNJ%20CANADA%20PRAN%20PRATISHTHA_page-0001.jpg" alt="" />
              </Link>
            </figure>

          </div>
          <div className="lower-content1">
            <h3><Link to="/USA/InaugurationEvents">  Grand Inauguration of Yugal Kunj </Link></h3>

            <div className="text1">

            Click here to get more info Yugal Kunj 
              <Link to="/USA/InaugurationEvents" className="readmore"> Read More</Link>



            </div>
            <Link to="/USA/InaugurationEvents" className="theme-btn1 btn-style-two1" target="_">
              <span className="btn-title1">
                <span className="icon fa fa-sign-in-alt" aria-hidden="true">
                </span> Read More </span>
            </Link>
          </div>



        </div>


      </div>


          

          </div>

        </div>
      </section>

    </>


  )


}

export default GrandInuagration;